// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MyApp_wrapper__ko9_Z"};